import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import { openModal } from "components/modal"
import { IS_CA, IS_NA, IS_JEWLR } from "helpers/application"
import { showHolidayShipMethodPDP } from "helpers/holiday"

import { ActionBtn, Text } from "./components"

const InternalShipText = ({
  hasDiamondSelector,
  holidayDelivery,
  ship,
  forHer,
}) => {
  // const holidayDelivery =
  //   ship?.min_delivery_date &&
  //   new Date(ship.min_delivery_date).getDate() <=
  //     new Date(sl.config.guaranteed_receive_date).getDate()
  const is_ca = IS_CA()
  const is_na = IS_NA()

  const holidayStyle = showHolidayShipMethodPDP && holidayDelivery && forHer
  const cutoffStyle = showHolidayShipMethodPDP && !holidayDelivery && forHer

  const showShippingInfo = () => openModal("#shipping-info")

  if (ship.delivery_dates?.length > 0) {
    if (ship.delivery_dates.length === 2) {
      return (
        <Box mb={holidayStyle ? { _: -1, tablet: 0 } : 0}>
          <Text
            cutoffStyle={cutoffStyle}
            holidayStyle={holidayStyle}
            second={!is_na}
          >
            Get it by <span>{ship.delivery_dates[0].date}</span> with{" "}
            <span>{ship.delivery_dates[0].type}</span>
          </Text>
          {/* <Text holidayStyle={(is_au || is_uk) && holidayDelivery}> */}
          <Text
            cutoffStyle={cutoffStyle}
            holidayStyle={holidayStyle}
            second={is_na}
          >
            Get it by <span>{ship.delivery_dates[1].date}</span> with{" "}
            <span>{ship.delivery_dates[1].type}</span>
          </Text>
          {is_ca && (
            <ActionBtn onClick={() => showShippingInfo()} variant="text">
              Change your postal code
            </ActionBtn>
          )}
        </Box>
      )
    } else {
      // Only one shipping method
      return (
        <>
          <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
            Get it by <span>{ship.delivery_dates[0].date}</span> with{" "}
            <span>{ship.delivery_dates[0].type}</span>.
          </Text>
          {is_ca && !hasDiamondSelector && (
            <div>
              <ActionBtn onClick={() => showShippingInfo()} variant="text">
                Change your postal code
              </ActionBtn>
            </div>
          )}
        </>
      )
    }
  } else if (ship.delivery_date_range) {
    // CA no postal code
    return (
      <Box mb={holidayStyle ? 0 : 1}>
        <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle} mb={0}>
          Get it <span>{ship.delivery_date_range[0]}</span> to{" "}
          <span>{ship.delivery_date_range[1]}</span> with{" "}
          <span>{IS_JEWLR() ? "FREE" : "Express"} Shipping</span>.
        </Text>
        <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle} second>
          To find out exact delivery date{" "}
          <ActionBtn
            data-cy="change-postal-button"
            mx={0}
            onClick={() => showShippingInfo()}
            variant="text"
          >
            check your postal code
          </ActionBtn>
          .
        </Text>
      </Box>
    )
  } else if (ship.view_type === "OUT_OF_STOCK") {
    return (
      <Text>
        We&apos;re sorry, this item is currently unavailable. Please check back
        soon!
      </Text>
    )
  } else {
    // Default no ship methods returned
    return (
      <Text cutoffStyle={cutoffStyle} holidayStyle={holidayStyle}>
        Get it by <span>{ship.esd}</span>.
      </Text>
    )
  }
}

InternalShipText.propTypes = {
  forHer: PropTypes.bool,
  hasDiamondSelector: PropTypes.bool,
  holidayDelivery: PropTypes.bool,
  ship: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    forHer: state.wizard.forHer,
    hasDiamondSelector: state.wizard.hasDiamondSelector,
    holidayDelivery: state.wizard.shipping.main?.available_holiday_delivery,
    ship: state.wizard.shipping.main,
  }
}

const ShipText = connect(mapStateToProps)(InternalShipText)

export default ShipText
